import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import MyNominationCard from "./MyNominationCard";

const RecentNominationSummary = () => {
  

  return (
    <HeaderComponent
      title="Recent Nominations"
      titleClass="text-[16px] font-medium"
      description="Track the status of your award nominations"
      descriptionClass="text-sm muted-text"
      cardBorder="border"
    >
      <div className="max-h-[600px] overflow-y-auto">
        <MyNominationCard/>
      </div>
    </HeaderComponent>
  );
};

export default RecentNominationSummary;
